import React from "react";
import { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import List from "../../components/List/List";
import useFetch from "../../hooks/useFetch";

const Products = () => {
  const catId = useParams().id;
  const [maxPrice, setMaxPrice] = useState(Number(process.env.REACT_APP_PRODUCT_RANGE));
  const location = useLocation();
  const [sort, setSort] = useState(null);
  const [selectedSubCats, setSelectedSubCats] = useState([]);
  const [subcatLoading, setSubcatLoading] = useState(false);
  const { data, loading, error } = useFetch(`/sub-categories?categories=${catId}`, 'NoToken');

  useEffect(() => {
    // Parse the query string to get default selected values
    const queryParams = new URLSearchParams(location.search);
    const defaults = queryParams.get('sub_categories')?.split(',') || [];
    setSelectedSubCats(defaults); // Initialize with values from query string
    setSubcatLoading(true);
  }, [location.search]);
  
  const handleCheckboxChange = (value) => {
    setSelectedSubCats((prev) =>
        prev.includes(value)
            ? prev.filter((item) => item !== value) // Remove if already selected
            : [...prev, value] // Add if not selected
    );
  };

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-lg-3">
          <h1 className="h2 pb-4">Filters</h1>
          <ul className="list-unstyled templatemo-accordion">
              <li className="pb-3">
                  <a className="collapsed d-flex justify-content-between h3 text-decoration-none" href="#">
                      Categories
                      <i className="fa fa-fw fa-chevron-circle-down mt-1"></i>
                  </a>
                  <ul className="filters collapse show list-unstyled pl-3">
                    {data?.map((item) => (
                      <li key={item.id}><input type="checkbox" value={item.title_slug} 
                        onChange={() => handleCheckboxChange(String(item.title_slug))} 
                        checked={selectedSubCats.includes(String(item.title_slug))} />
                        <label htmlFor={item.title_slug}>{item.title}</label>
                      </li>
                    ))}
                  </ul>
              </li>
              <li className="pb-3">
                  <a className="collapsed d-flex justify-content-between h3 text-decoration-none" href="#">
                      Sort By
                      <i className="pull-right fa fa-fw fa-chevron-circle-down mt-1"></i>
                  </a>
                  <ul id="collapseTwo" className="filters collapse list-unstyled pl-3">
                      <li><input type="radio" id="asc" value="asc" name="price"
                        onChange={(e) => setSort("asc")} />
                        <label htmlFor="asc">Price (Lowest first)</label></li>
                      <li><input type="radio" id="desc" value="desc" name="price" 
                        onChange={(e) => setSort("desc")} />
                        <label htmlFor="desc">Price (Highest first)</label></li>
                  </ul>
              </li>
              <li className="pb-3">
                  <a className="collapsed d-flex justify-content-between h3 text-decoration-none" href="#">
                      Price
                      <i className="pull-right fa fa-fw fa-chevron-circle-down mt-1"></i>
                  </a>
                  <ul id="collapseThree" className="filters collapse list-unstyled pl-3">
                      <li><span>0</span><input type="range" min={0} max={Number(process.env.REACT_APP_PRODUCT_RANGE)}
                        onChange={(e) => setMaxPrice(e.target.value)} /><span>{maxPrice}</span></li>
                  </ul>
              </li>
          </ul>
        </div>
        <div className="col-lg-9">
          {/*<div className="row">
            <div className="col-md-6">
              <ul className="list-inline shop-top-menu pb-3 pt-1">
                <li className="list-inline-item">
                  <a className="h3 text-dark text-decoration-none mr-3" href="#">All</a>
                </li>
                <li className="list-inline-item">
                  <a className="h3 text-dark text-decoration-none mr-3" href="#">Men's</a>
                </li>
                <li className="list-inline-item">
                  <a className="h3 text-dark text-decoration-none" href="#">Women's</a>
                </li>
              </ul>
            </div>
            <div className="col-md-6 pb-4">
              <div className="d-flex">
                <select className="form-control">
                  <option>Featured</option>
                  <option>A to Z</option>
                  <option>Item</option>
                </select>
              </div>
            </div>
          </div>*/}
          {subcatLoading ? 
          <List catId={catId} maxPrice={maxPrice} sort={sort} subCats={selectedSubCats}/> : 
          <div className="text-center">Loading...</div>}
        </div>
      </div>
    </div>
  );
};

export default Products;